module.exports = "https://static.wmbcdn.com/uniweb/images/f19e833cf3e83f6b5301d9bc2211dd53.svg";